import React from 'react';

import _ from 'lodash';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';

const styles = {
  label: {
    color: 'grey',
    fontSize: 12,
  }
};

const ContactInput = ({ label, value = {}, onChange, onSendSms, onSendEmail }) => {
  return (
    <Grid container spacing={8}>
      {label ? <Grid item xs={12}><span style={styles.label}>{label}</span></Grid> : null}
      <Grid item xs={4}>
        <TextField
          name="name"
          label="Name"
          fullWidth
          value={value.name || ''}
          onChange={(evt) => onChange(_.assign({}, value, { name: evt.target.value }))}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          name="mobile"
          label="Mobile"
          fullWidth
          value={value.mobile ? value.mobile.number : ''}
          onChange={(evt) => onChange(_.assign({}, value, { mobile: evt.target.value }))}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="Send SMS">
                  <IconButton onClick={() => onSendSms(value)}>
                    <SendIcon/>
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          name="email"
          label="Email"
          fullWidth
          value={value.email || ''}
          onChange={(evt) => onChange(_.assign({}, value, { email: evt.target.value }))}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="Send Email">
                  <IconButton onClick={() => onSendEmail(value)}>
                    <SendIcon/>
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </Grid>);
};

export default ContactInput;



// WEBPACK FOOTER //
// ./src/components/Common/ContactInput/index.js